export default class DebouncedResize {
    constructor(after_callback, before_callback, run_callback_on_init) {
        this.timeout_function_id;
        this.before_callback_called = false;

        if(run_callback_on_init == true) {
            after_callback();
        }

        window.addEventListener('resize', () => {
            if(!this.before_callback_called && before_callback) {
                this.before_callback_called = true;
                before_callback();
            }

            clearTimeout(this.timeout_function_id);

            this.timeout_function_id = setTimeout(() => {
                after_callback();
                this.before_callback_called = false;
            }, 500);
        });
    }
}
